import React, { useState, setState, useEffect, useContext } from "react";
import axios from "axios";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

export default function Sports(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    formControl: {
      minWidth: 120,
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "100%",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));
  const classes = useStyles();
  const [sports, setSports] = React.useState([]);
  const [selectedSport, setSelectedSport] = React.useState("");

  useEffect(() => {
    // Change for server api address
    const url = process.env.REACT_APP_API2_URL + "/Player/GetSports";
    axios({
      method: "get",
      url: url,
    }).then((response) => {
      const data = response.data;
      setSports(data);
      const firstSport = data?.[0]?.idSport;
      if (firstSport) {
        setSelectedSport(firstSport);
        props.setIdSportOnMem(firstSport);
      }
    });
  }, []);

  const options = {
    page: 1, // which page you want to show as default
    sizePerPageList: [
      {
        text: "15",
        value: 15,
      },
      {
        text: "50",
        value: 50,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "1000",
        value: 1000,
      },
    ], // you can change the dropdown list for size per page
    sizePerPage: 16, // which size per page you want to locate as default
    pageStartIndex: 1, // where to start counting the pages
    paginationSize: 3, // the pagination bar size.
    prePage: "Prev", // Previous page button text
    nextPage: "Next", // Next page button text
    firstPage: "First", // First page button text
    lastPage: "Last", // Last page button text
    paginationShowsTotal: true, // Accept bool or function
    paginationPosition: "bottom", // default is bottom, top and both is all available
    
    onRowClick: selectedValues,
  };

  function selectedValues(row) {
    // setRedirect(row);
  }
  const cellEditProp = {
    mode: "click",
    blurToSave: true,
  };

  /*Select Functions*/

  const selectRowProp = {
    mode: "checkbox",
    clickToSelect: true,
    clickToExpand: true,
  };

  const handleChange = (event) => {
    props.setIdSportOnMem(event.target.value);
    setSelectedSport(event.target.value);
  };
  /*End Select Functions*/

  if (props.showDataTable) {
    return (
      <React.Fragment>
        <BootstrapTable
          data={sports}
          cellEdit={cellEditProp}
          options={options}
          pagination={true}
          version="4"
          hover
          selectRow={props.enableRowSelection ? selectRowProp : {}}
        >
          <TableHeaderColumn visible="none" isKey={true} dataField="idSport">
            ID
          </TableHeaderColumn>
          <TableHeaderColumn hidden={props.hiddenColumn} dataField="sportName">SportName</TableHeaderColumn>
        </BootstrapTable>
      </React.Fragment>
    );
  } else if (props.showMinimalSelect) {
    return (
      <React.Fragment>
        <FormControl
          className={classes.formControl}
          variant="outlined"
          size="small"
        >
          <Select
            labelId="demo-simple-select-placeholder-label-label"
            id="demo-simple-select-placeholder-label"
            //value={sports[0] && sports[0]['IdSport']}
            value={selectedSport}
            onChange={handleChange}
            displayEmpty
          >
            <MenuItem value={"NFL  "}>NFL</MenuItem>
            <MenuItem value={"CFB  "}>CFB</MenuItem>
            <MenuItem value={"NBA  "}>NBA</MenuItem>
            <MenuItem value={"CBB  "}>CBB</MenuItem>
          </Select>

          <FormHelperText>Select Sport</FormHelperText>
        </FormControl>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <FormControl
          className={`${classes.formControl} w-full`}
          variant="outlined"
          size="small"
        >
          <InputLabel id="demo-simple-select-placeholder-label-label">
            Sport
          </InputLabel>
          {sports[0] && (
            <Select
              labelId="demo-simple-select-placeholder-label-label"
              id="demo-simple-select-placeholder-label"
              className="w-full"
              //value={sports[0] && sports[0]['IdSport']}
              value={selectedSport}
              onChange={handleChange}
              displayEmpty
            >
              {sports.map((sport) => (
                <MenuItem key={sport.idSport} value={sport.idSport}>
                  {sport.sportName}
                </MenuItem>
              ))}
            </Select>
          )}

          {/* <FormHelperText>Select Sport</FormHelperText> */}
        </FormControl>
      </React.Fragment>
    );
  }
}
